import { render, staticRenderFns } from "./EditMilestones.vue?vue&type=template&id=ec43c124&scoped=true&"
import script from "./EditMilestones.vue?vue&type=script&lang=js&"
export * from "./EditMilestones.vue?vue&type=script&lang=js&"
import style0 from "./EditMilestones.vue?vue&type=style&index=0&id=ec43c124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec43c124",
  null
  
)

export default component.exports